import styled from 'styled-components'
import { maxWidth } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'
import { keyframes } from 'styled-components'

const appear = keyframes`
  0% {
    opacity: 0;
    transform: translateY(6px);
  }

  100% {
    opacity: 1;
    transform: none;
  }
`

const PriceList = styled.div``

PriceList.Items = styled.dl`
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(150px, max-content);
  align-items: flex-start;
  border: 1px solid rgba(var(--color-border-rgb), 0.5);
  border-top: none;

  ${maxWidth(vars.breakpoints.tablet)`
    grid-template-columns: minmax(0, 1fr) minmax(100px, max-content);
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    grid-template-columns: minmax(0, 1fr);
  `}
`

PriceList.Name = styled.dt`
  padding: 27px 20px 28px 24px;
  border-top: 1px solid rgba(var(--color-border-rgb), 0.5);
  animation: ${appear} 0.4s ease-in-out;

  ${maxWidth(vars.breakpoints.tablet)`
    padding: 24px 20px 23px 24px;
    font-size: 14px;
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    padding: 22px 20px 11px 20px;
    border-top: 1px solid rgba(var(--color-border-rgb), 0.5);
  `}
`

PriceList.Value = styled.dd`
  padding: 0 24px 0 12px;
  font-weight: 500;
  line-height: 74px;
  white-space: nowrap;
  border-top: 1px solid rgba(var(--color-border-rgb), 0.5);
  animation: ${appear} 0.4s ease-in-out;

  ${maxWidth(vars.breakpoints.tablet)`
    font-size: 14px;
    font-weight: bold;
    line-height: 63px;
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    padding: 11px 20px 23px 20px;
    line-height: 1.2;
    white-space: normal;
    border-top: none;
  `}
`

PriceList.Button = styled.div`
  margin-top: 32px;
  text-align: center;
`

export default PriceList
